import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { fetchCartItems } from './thunks';
import type { CartItem, CartState, EntityId } from './types';

const initialState: CartState = {
  cart: [],
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<CartItem>) => {
      const hasItem = state.cart.find((item) => item.id === action.payload.id);

      if (hasItem) {
        state.cart = state.cart.map((item) => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              qt: `${+item.qt! + 1}`,
            };
          }
          return item;
        });
      } else {
        state.cart = [...state.cart, { ...action.payload, qt: 1 }];
      }
    },
    removeFromCart: (state, action: PayloadAction<EntityId>) => {
      const currentItem = state.cart.find((item) => item.id === action.payload);
      const qt = Number(currentItem?.qt ?? 0);

      if (qt > 1) {
        state.cart = state.cart.map((item) => {
          if (item.id === action.payload) {
            return {
              ...item,
              qt: `${qt - 1}`,
            };
          }
          return item;
        });
      } else {
        state.cart = state.cart.filter((item) => item.id !== action.payload);
      }
    },
    clearCart: (state) => {
      state.cart = [];
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchCartItems.fulfilled, (state, action) => {
      state.cart = action.payload ?? [];
    });
    builder.addCase(fetchCartItems.rejected, () => {
      // keep whatever is already in the cart; don't blank it on a transient fetch failure
    });
  },
});

export const { addToCart, removeFromCart, clearCart } = cartSlice.actions;
export const cartReducer = cartSlice.reducer;
